/**
 * settingsJump — TZ 2026-09-23 Блок 10: кнопка «Перейти» из попапа «Проверить всё»
 * и общий формат «куда прыгнуть» внутри настроек.
 *
 * Формат: { tab, operation, moduleKey, tier } —
 *   tab: верхний таб страницы настроек ('moduleConfigs' | ...),
 *   operation: таб операции внутри ModuleConfigsAdmin ('search' | 'matching' | ...),
 *   moduleKey/tier — для подсветки нужной карточки конфига.
 *
 * Ограничение зоны: SettingsSystemPage сейчас вне зоны этого агента (там
 * работает другой агент), поэтому верхний таб этой версией не переключается —
 * событие window 'cs:settings-jump' рассылается, слушатель «переключить
 * верхний таб» — 5-строчный обработчик в SettingsSystemPage (см. отчёт).
 */
export interface SettingsJumpTarget {
  tab: string;
  operation?: string;
  moduleKey?: string;
  tier?: string;
}

export const SETTINGS_JUMP_EVENT = 'cs:settings-jump';

let lastTarget: SettingsJumpTarget | null = null;

/** Отправить прыжок: sessionStorage-маркер (пересоздание таба) + window-событие. */
export function sendSettingsJump(target: SettingsJumpTarget): void {
  lastTarget = target;
  try {
    sessionStorage.setItem('cs.settings.jump', JSON.stringify(target));
  } catch {
    /* sessionStorage может быть недоступен — событие всё равно уйдёт */
  }
  window.dispatchEvent(
    new CustomEvent<SettingsJumpTarget>(SETTINGS_JUMP_EVENT, { detail: target }),
  );
}

/** Модуль-скип: если событие ушло до монтирования слушателя. */
export function consumeLastJump(): SettingsJumpTarget | null {
  const t = lastTarget;
  lastTarget = null;
  return t;
}

/** Прочитать сохранённый прыжок (переживает remount таба). */
export function readSettingsJump(): SettingsJumpTarget | null {
  try {
    const raw = sessionStorage.getItem('cs.settings.jump');
    return raw ? (JSON.parse(raw) as SettingsJumpTarget) : null;
  } catch {
    return null;
  }
}